<div class="page-layout">
  <app-sidebar></app-sidebar>

  <div class="main-area">
    <app-navbar pageTitle="Query Activity" pageSubtitle="How an individual query moves through the brain"></app-navbar>

    <div class="content">
      <app-empty-state
        title="Coming soon"
        message="The detailed, query-by-query breakdown will be designed here in a later pass."
      ></app-empty-state>
    </div>
  </div>
</div>
